import { CodedError } from 'expo-modules-core';

export function getContext(canvas: HTMLCanvasElement): CanvasRenderingContext2D {
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new CodedError('ERR_IMAGE_MANIPULATOR', 'Failed to create canvas context');
  }
  return ctx;
}

const SAFARI_MOBILE_CANVAS_LIMIT = 4096; 

const isMobileIOS = () => {
    const userAgent = navigator.userAgent;
    return /iP(ad|od|hone)/i.test(userAgent) && /(WebKit|CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent);
};

export async function blobToBase64String(blob: Blob): Promise<string> {
  const dataURL = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () =>
      reject(new Error(`Unable to convert blob to base64 string: ${reader.error}`));
    reader.readAsDataURL(blob);
  });
  return dataURL.replace(/^data:image\/\w+;base64,/, '');
}

function getAdjustedCanvasSize(originalWidth, originalHeight) {
    if(!isMobileIOS()) return { width: originalWidth, height: originalHeight };

    const aspectRatio = originalWidth / originalHeight;
    let newWidth;
    let newHeight;

    if (originalWidth <= SAFARI_MOBILE_CANVAS_LIMIT && originalHeight <= SAFARI_MOBILE_CANVAS_LIMIT) {
        return { width: originalWidth, height: originalHeight };
    }

    if (aspectRatio > 1) {
        newWidth = SAFARI_MOBILE_CANVAS_LIMIT;
        newHeight = Math.round(newWidth / aspectRatio);
    } else {
        newHeight = SAFARI_MOBILE_CANVAS_LIMIT;
        newWidth = Math.round(newHeight * aspectRatio);
    }

    if (newWidth > SAFARI_MOBILE_CANVAS_LIMIT) {
        newWidth = SAFARI_MOBILE_CANVAS_LIMIT;
        newHeight = Math.round(newWidth / aspectRatio);
    } else if (newHeight > SAFARI_MOBILE_CANVAS_LIMIT) {
        newHeight = SAFARI_MOBILE_CANVAS_LIMIT;
        newWidth = Math.round(newHeight * aspectRatio);
    }

    return { width: newWidth, height: newHeight };
}

export function loadImageAsync(uri: string): Promise<HTMLCanvasElement> {
  return new Promise((resolve, reject) => {
    const imageSource = new Image();
    imageSource.crossOrigin = 'anonymous';
    const canvas = document.createElement('canvas');
    imageSource.onload = () => {
      const adjudstedCanvasSize = getAdjustedCanvasSize(imageSource.naturalWidth, imageSource.naturalHeight);

      canvas.width = adjudstedCanvasSize.width;
      canvas.height = adjudstedCanvasSize.height;

      const context = getContext(canvas);
      context.drawImage(imageSource, 0, 0, adjudstedCanvasSize.width, adjudstedCanvasSize.height);

      resolve(canvas);
    };
    imageSource.onerror = () => reject(canvas);
    imageSource.src = uri;
  });
}
